var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCareer8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16 3 C 14.148438 3 12.59375 4.285156 12.144531 6 L 3 6 L 3 26 L 19.4375 26 C 19.210938 25.367188 19.074219 24.695313 19.027344 24 L 5 24 L 5 19 L 20.515625 19 C 21.125 18.191406 21.890625 17.507813 22.773438 17 L 5 17 L 5 8 L 27 8 L 27 16.027344 C 27.695313 16.074219 28.367188 16.210938 29 16.4375 L 29 6 L 19.855469 6 C 19.40625 4.285156 17.851563 3 16 3 Z M 16 5 C 16.75 5 17.386719 5.402344 17.730469 6 L 14.269531 6 C 14.613281 5.402344 15.25 5 16 5 Z M 16 14 C 15.449219 14 15 14.449219 15 15 C 15 15.550781 15.449219 16 16 16 C 16.550781 16 17 15.550781 17 15 C 17 14.449219 16.550781 14 16 14 Z M 26.5 18 C 23.5 18 21 20.5 21 23.5 C 21 24.699219 21.398438 25.699219 22 26.597656 L 18.300781 30.300781 L 19.699219 31.699219 L 23.402344 28 C 24.300781 28.601563 25.398438 29 26.5 29 C 29.5 29 32 26.5 32 23.5 C 32 20.5 29.5 18 26.5 18 Z M 26.5 20 C 28.398438 20 30 21.601563 30 23.5 C 30 25.398438 28.398438 27 26.5 27 C 24.601563 27 23 25.398438 23 23.5 C 23 21.601563 24.601563 20 26.5 20 Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCareer8);
export default __webpack_public_path__ + "static/media/icons-career8.73a401a662ccb6c2410d054a2e39188a.svg";
export { ForwardRef as ReactComponent };